import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  APP_INITIALIZER,
  RendererFactory2,
  ErrorHandler,
} from '@angular/core';
import {
  BrowserModule,
  provideClientHydration,
} from '@angular/platform-browser';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SwiperModule } from 'swiper/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  InpageSearchComponent,
  RadioComponent,
  RadioGroupComponent,
  FooterComponent,
  ButtonComponent,
  TeaserComponent,
  AlertComponent,
  AccordionComponent,
  BreadcrumbsComponent,
  LinkComponent,
  UtilitiesCardsComponent,
  HeaderStageComponent,
  FlyoutComponent,
  TooltipComponent,
  ConfigService,
  ContactModuleComponent,
  CrossReferencingComponent,
  DistractorComponent,
  ExpandComponent,
  StaticGraphicComponent,
  SliderComponent,
  DynamicTeaserShowcaseComponent,
  FilterBarComponent,
  TermineComponent,
  HighlightcardComponent,
  TopBarComponent,
  GlobalSearchComponent,
  InfoTeasersComponent,
  HighlightcardListComponent,
  TeaserContainerComponent,
  DistractorSectionComponent,
  InpageNavigationComponent,
  NotFoundBoxComponent,
  TextBlockComponent,
  PrefooterComponent,
  NewstickerComponent,
  MaterialDownloadComponent,
  PodcastComponent,
  ToTopButtonComponent,
  ModalComponent,
  PageComponent,
  PageLoaderComponent,
  ImageComponent,
} from 'hdi-components/source';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_BASE_HREF } from '@angular/common';
import { HomeStageComponent } from '../../../hdi-components/src/lib/organisms/home-stage/home-stage.component';

import { QuoteComponent } from '../../../hdi-components/src/lib/molecules/quote/quote.component';
import { SectionComponent } from '../../../hdi-components/src/lib/organisms/section/section.component';

import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  provideHttpClient,
  withFetch,
} from '@angular/common/http';
import { HomePageComponent } from './home/home-page.component';
import { SpinnerComponent } from '../../../hdi-components/src/lib/atoms/spinner/spinner.component';
import { ErrorPageComponent } from './error/error-page.component';
import { StandardPageComponent } from './standard/standard-page.component';
import { LoadingInterceptor } from '../interceptors/loading.interceptor';
import { StageComponent } from '../../../hdi-components/src/lib/organisms/stage/stage.component';
import { CapitalizePipe } from '../../../hdi-components/src/lib/capitalize.pipe';
import { loadScriptsFactory } from '../services/script-loader.factory';
import { CaasContentService } from '../services/caas-content.service';
import { GlobalErrorHandler } from '../error-handling/global-error-handler';

import { environment } from '../environments/environment';
import { RedirectExternalRouteGuard } from '../guards/external-route.guard';

@NgModule({
  declarations: [
    AppComponent,
    ErrorPageComponent,
    HomePageComponent,
    StandardPageComponent,
  ],
  providers: [
    provideHttpClient(withFetch()),
    RedirectExternalRouteGuard,
    { provide: APP_BASE_HREF, useValue: '/' },
    {
      provide: ConfigService,
      useFactory: () => {
        const configService = new ConfigService();
        configService.setEnvironment(environment);
        return configService;
      },
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: loadScriptsFactory,
      deps: [CaasContentService, RendererFactory2],
      multi: true,
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideClientHydration(),
  ],
  bootstrap: [AppComponent],
  imports: [
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    PageComponent,
    PageLoaderComponent,
    TeaserComponent,
    InpageSearchComponent,
    FooterComponent,
    RadioGroupComponent,
    RadioComponent,
    ButtonComponent,
    AccordionComponent,
    AlertComponent,
    InpageSearchComponent,
    BreadcrumbsComponent,
    LinkComponent,
    UtilitiesCardsComponent,
    HeaderStageComponent,
    FlyoutComponent,
    HomeStageComponent,
    TooltipComponent,
    ContactModuleComponent,
    PrefooterComponent,
    CrossReferencingComponent,
    DistractorComponent,
    ExpandComponent,
    StaticGraphicComponent,
    MaterialDownloadComponent,
    SliderComponent,
    DynamicTeaserShowcaseComponent,
    FilterBarComponent,
    TermineComponent,
    PodcastComponent,
    HighlightcardComponent,
    ImageComponent,
    QuoteComponent,
    SectionComponent,
    InpageNavigationComponent,
    TopBarComponent,
    GlobalSearchComponent,
    NewstickerComponent,
    HighlightcardListComponent,
    TeaserContainerComponent,
    DistractorSectionComponent,
    InfoTeasersComponent,
    NotFoundBoxComponent,
    TextBlockComponent,
    HttpClientModule,
    SpinnerComponent,
    ToTopButtonComponent,
    ModalComponent,
    SwiperModule,
    StageComponent,
    CapitalizePipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
